import React, { useRef, useState } from "react";
import {
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
} from "reactstrap";
import styles from "./addproduct.module.scss";
import Proptypes from "prop-types";
import StepOneProgress from "../../../../assets/images/brand-steps-progress-indicator/step-one.svg";
import ImageUploadIcon from "../../../../assets/images/image-upload-icon.svg";
import DeleteIcon from "../../../../assets/images/delete-icon.svg";
import { toast } from "react-toastify";
import Textfield from "../../../Shared/Textfield";
import Button from "../../../Shared/Button";
import { useSelector } from "react-redux";

const StepOne = ({
  handleChange,
  toggle,
  setStep,
  step,
  formData,
  isEdit,
  categories,
}) => {
  const inputRef = useRef();
  const brandsData = useSelector((state) => state?.appReducer?.brands);

  const brandsFormattedData = (brandsData || [])?.map((brandData) => {
    return {
      name: brandData?.brandName,
      id: brandData?.id,
    };
  });

  const [brandsDropdownOpen, setBrandsDropdownOpen] = useState(false);
  const [categoryDropdown, setCategoryDropdown] = useState(false);

  const handleDragOver = (event) => {
    event.preventDefault();
  };

  const handleDrop = (event) => {
    event.preventDefault();
    const droppedFiles = Array.from(event.dataTransfer.files);
    const validFiles = droppedFiles.filter((file) =>
      file.type.match(
        "image/png|image/jpg|image/jpeg|application/pdf|application/msword|application/vnd.openxmlformats-officedocument.wordprocessingml.document"
      )
    );
    if (validFiles.length !== droppedFiles.length) {
      toast.warning("Only PNG, JPG, PDF, DOC, or DOCX files are allowed.");
    }
    const updatedFiles = [...(formData.values.documents || []), ...validFiles];
    if (updatedFiles.length > 4) {
      toast.warning("Only 4 documents allowed.");
      return;
    }
    handleChange({
      target: { name: "documents", value: updatedFiles },
    });
  };

  const brandsValue = formData?.values?.Brand;

  const handleNext = () => {
    formData.setTouched({
      ...formData.touched,
      Brand: true,
      Category: true,
      Name: true,
      GlobalTradeItemNumber: true,
      Description: true,
      price: true,
    });

    if (formData.isValid && formData.dirty) {
      setStep(step + 1);
    } else {
      toast.error("Please fill out all required fields correctly.");
    }
  };

  return (
    <>
      <div className={styles["header_content"]}>
        <div className={styles["header_container"]}>
          <p className={styles["header_heading"]}>
            {isEdit ? "Edit" : "Add"} product
          </p>
        </div>
        <div className={styles["progress_container"]}>
          <div className={styles["progress_container_indicator"]}>
            <img
              src={StepOneProgress || "/"}
              width={232}
              height={42}
              alt="progress"
            />
          </div>
        </div>
        <div style={{ width: "116px" }}></div>
      </div>
      <div className={styles["label_container"]}>
        Let's get a little bit of info on the product (* indicates that it can
        not be changed later)
      </div>

      <div className={styles["step_one_content"]}>
        <div
          className={`${styles["content_container"]} ${styles["form_fields_container"]}`}
        >
          <Dropdown
            isOpen={brandsDropdownOpen}
            toggle={() => {
              setBrandsDropdownOpen(!brandsDropdownOpen);
            }}
          >
            <DropdownToggle className={styles["colors_dropdown"]}>
              {brandsValue ? brandsValue : "Brand*"}
            </DropdownToggle>
            <DropdownMenu className={styles["menu_dropdown"]}>
              {(brandsFormattedData || [])?.map((brand, index) => {
                return (
                  <DropdownItem
                    className={styles["dropdown_item"]}
                    onClick={() => {
                      formData.setFieldValue("Brand", brand.name);
                      formData.setFieldValue("brandID", brand.id);
                    }}
                    key={index}
                  >
                    <div>{brand?.name || ""}</div>
                  </DropdownItem>
                );
              })}
            </DropdownMenu>
          </Dropdown>
          {formData?.touched?.Brand && formData?.errors?.Brand && (
            <div className={styles["file_error"]}>
              {formData?.errors?.Brand}
            </div>
          )}

          <Textfield
            type="number"
            placeholder="Price"
            name="price"
            id="Name"
            value={formData?.values?.price}
            onChange={handleChange}
            className={styles["input_field_container"]}
            error={formData?.errors?.price}
            touched={formData?.touched?.price}
          />
          <Textfield
            type="text"
            placeholder="Name*"
            name="Name"
            id="Name"
            value={formData?.values?.Name}
            onChange={handleChange}
            className={styles["input_field_container"]}
            error={formData?.errors?.Name}
            touched={formData?.touched?.Name}
          />

          <Dropdown
            isOpen={categoryDropdown}
            toggle={() => {
              setCategoryDropdown(!categoryDropdown);
            }}
          >
            <DropdownToggle className={styles["colors_dropdown"]}>
              {formData?.values.Category
                ? formData?.values.Category
                : "Category*"}
            </DropdownToggle>
            <DropdownMenu className={styles["menu_dropdown"]}>
              {categories?.length === 0 && (
                <DropdownItem className={styles["dropdown_item"]} disabled>
                  <div>Data Not Found!</div>
                </DropdownItem>
              )}
              {(categories || [])?.map((brand, index) => {
                return (
                  <DropdownItem
                    className={styles["dropdown_item"]}
                    onClick={() => {
                      formData.setFieldValue("Category", brand.name);
                    }}
                    key={index}
                  >
                    <div>{brand?.name || ""}</div>
                  </DropdownItem>
                );
              })}
            </DropdownMenu>
          </Dropdown>

          {formData?.touched?.Category && formData?.errors?.Category && (
            <div className={styles["file_error"]}>
              {formData?.errors?.Category}
            </div>
          )}

          <Textfield
            name="GlobalTradeItemNumber"
            id="GlobalTradeItemNumber"
            value={formData?.values?.GlobalTradeItemNumber}
            onChange={handleChange}
            type="text"
            placeholder="GTIN*"
            className={`${styles["input_field_container"]}`}
            error={formData?.errors?.GlobalTradeItemNumber}
            touched={formData?.touched?.GlobalTradeItemNumber}
            disabled={Boolean(isEdit)}
          />

          <Textfield
            name="Description"
            id="Description"
            value={formData?.values?.Description}
            onChange={handleChange}
            type="textarea"
            placeholder="Description*"
            className={`${styles["input_field_container"]} ${styles["text_area_container"]}`}
            error={formData?.errors?.Description}
            touched={formData?.touched?.Description}
          />
        </div>
        <div className={styles["content_container"]}>
          <div
            className={styles["file_upload_container"]}
            onClick={() => {
              inputRef?.current?.click();
            }}
            role="button"
            tabIndex={0}
            onKeyDown={() => {}}
            onDragOver={handleDragOver}
            onDrop={handleDrop}
          >
            <div>
              <img
                src={ImageUploadIcon || "/placeholder.svg"}
                alt="img"
                width={24}
                height={24}
              />
            </div>
            <div>
              <p className={styles["upload_text"]}>
                Documents upload (Drag and drop)
              </p>
            </div>
          </div>
          <input
            type="file"
            accept=".png, .jpg, .jpeg, .pdf, .doc, .docx"
            ref={inputRef}
            style={{
              display: "none",
            }}
            name="Images"
            id="Images"
            multiple
            onChange={(event) => {
              const filesArray = Array.from(event.target.files || []);
              if (filesArray.length > 4) {
                toast.warning("Only 4 documents allowed.");
                return;
              }
              const updatedFiles = [
                ...(formData.values.Images || []),
                ...filesArray,
              ];
              handleChange({
                target: { name: "Images", value: updatedFiles },
              });
            }}
          />
          <div className={styles["documents_view_container"]}>
            {(formData.values.Images || []).map((file, index) => (
              <div className={styles["document_view"]} key={index}>
                <div
                  className={styles["delete_icon"]}
                  onClick={() => {
                    const currentFiles = [...formData.values.Images];
                    currentFiles.splice(index, 1);
                    handleChange({
                      target: { name: "Images", value: currentFiles },
                    });
                  }}
                  role="button"
                  tabIndex={0}
                  onKeyDown={() => {}}
                >
                  <img
                    src={DeleteIcon || "/placeholder.svg"}
                    width={25}
                    height={25}
                    alt="delete"
                  />
                </div>
                <div className={styles["image_name"]}>{file.name}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
      <div className={styles["buttons_container"]}>
        <div>
          <Button
            className={`${styles["button_cancel"]} ${styles["button_layout"]}`}
            onClick={toggle}
            text="Cancel"
          />
        </div>
        <div>
          <Button
            className={`${styles["button_active"]} ${styles["button_layout"]}`}
            onClick={handleNext}
            text="Next"
          />
        </div>
      </div>
    </>
  );
};

StepOne.propTypes = {
  handleChange: Proptypes.func,
  toggle: Proptypes.func,
  setStep: Proptypes.func,
  step: Proptypes.number,
  formData: Proptypes.object,
  isEdit: Proptypes.bool,
};
export default StepOne;
